import React from "react";

interface CTASectionProps {
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
}) => {
  return (
    <section className="bg-red-50 py-16">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold mb-8">{title}</h2>
        <p className="text-xl mb-8">{description}</p>
        <form className="max-w-md mx-auto">
          <input
            type="email"
            placeholder="Enter your email"
            className="w-full px-4 py-3 rounded-lg mb-4"
          />
          <button
            type="button"
            onClick={onButtonClick}
            className="bg-red-500 text-white px-8 py-3 rounded-lg font-bold hover:bg-red-600 transition w-full"
          >
            {buttonText}
          </button>
        </form>
      </div>
    </section>
  );
};

export default CTASection;